import { HTTPVerbs, type RequestOptions } from '@nextgen-web-framework/core';

export function getContentStackReqObj(versionId: string, isBundle: boolean): RequestOptions {
  const productTypeString = isBundle ? 'bundle' : 'prd';
  return {
    url: `/comproductas/${versionId}/cms/${productTypeString}/fetch-entries`,
    method: HTTPVerbs.POST,
    headers: {
      'Content-Type': 'application/json',
    },
    retries: 0,
  };
}

export default { getContentStackReqObj };
